/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
export default () => {
  const tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  const arrowBtn = document.querySelector(".js-hero-video-arrow-btn");
  const nextContainer = findNextElementWithClass(arrowBtn, "container");
  if (nextContainer !== null) {
    nextContainer.style.scrollMarginTop = "125px";
  }

  const nextFocusableEl = findFirstFocusableElement(nextContainer);
  if (arrowBtn) {
    arrowBtn.addEventListener("click", () => {
      if (nextContainer === null) {
        return;
      }
      nextContainer.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });

      var scrollTimeout;
      addEventListener("scroll", () => {
        clearTimeout(scrollTimeout);

        scrollTimeout = setTimeout(() => {
          if (nextFocusableEl === null) {
            return;
          }
          nextFocusableEl?.focus();
        }, 100);
      });
    });
  }
};

function initYouTubePlayers() {
  const players = document.querySelectorAll(".js-hero-video");

  if (players) {
    players.forEach((el) => {
      const videoContainer = el.querySelector(".js-hero-video-container");
      const videoOverlay = el.querySelector(".js-hero-video-overlay");
      const playBtn = el.querySelector(".js-hero-video-play-btn");

      // YT is defined on the window level by the above function
      // eslint-disable-next-line no-undef
      const player = new YT.Player(videoContainer, {
        height: "auto",
        width: "100%",
        videoId: videoContainer.id,
        playerVars: {
          rel: 0,
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: (event) =>
            onPlayerStateChange(event, videoOverlay, player),
        },
      });

      if (playBtn) {
        playBtn.addEventListener("click", () =>
          handlePlayButtonClick(videoOverlay, player)
        );
      }
    });
  }
}

function onPlayerReady(e) {}

function handlePlayButtonClick(videoOverlay, player) {
  toggleVideoDisplay(videoOverlay, true);
  player.playVideo();
}

function toggleVideoDisplay(videoOverlay, displayVideo ) {
  const videoOverlayClass = "hero-video__overlay--hidden";
  if (displayVideo) {
    videoOverlay.classList.add(videoOverlayClass);
  } else {
    videoOverlay.classList.remove(videoOverlayClass);
  }
}

function onPlayerStateChange(event, videoOverlay, player) {
  const YTPlayerStates = {
    UNSTARTED: -1,
    ENDED: 0,
    PLAYING: 1,
    PAUSED: 2,
    BUFFERING: 3,
    CUED: 5,
  };

  switch (event.data) {
    case YTPlayerStates.ENDED:
      toggleVideoDisplay(videoOverlay, false);
      break;
    case YTPlayerStates.PLAYING:
      break;
    case YTPlayerStates.PAUSED:
      break;
    default:
      break;
  }
}

// When API loads, this function is called
window.onYouTubeIframeAPIReady = initYouTubePlayers;

function findNextElementWithClass(element, className) {
  if (!element) {
    return null;
  }
  let current = element.nextElementSibling;

  while (current) {
    if (current.classList.contains(className)) {
      return current;
    }

    current = current.nextElementSibling;
  }

  // If no sibling found, search in parent's siblings
  let parent = element.parentElement;
  while (parent) {
    let nextParentSibling = parent.nextElementSibling;
    while (nextParentSibling) {
      if (nextParentSibling.classList.contains(className)) {
        return nextParentSibling;
      }
      nextParentSibling = nextParentSibling.nextElementSibling;
    }
    parent = parent.parentElement;
  }

  return null;
}

function findFirstFocusableElement(container) {
  if (!container) {
    return null;
  }
  const focusableElements = container.querySelectorAll(
    'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
  );

  return focusableElements[0];
}
